import React, { useContext, useEffect } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CartContext } from "./CartContext";
import { PENDING_PAYMENT_KEY } from "./CheckOut";
import "../css/paysuccess.css";

const readPendingPayment = () => {
  try {
    const raw = window.sessionStorage.getItem(PENDING_PAYMENT_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (error) {
    return null;
  }
};

const PaymentResult = () => {
  const [searchParams] = useSearchParams();
  const { createOrder } = useContext(CartContext);
  const state = searchParams.get("state");
  const isSuccess = state === "success";

  useEffect(() => {
    if (state === "cancel") {
      window.sessionStorage.removeItem(PENDING_PAYMENT_KEY);
      return;
    }
    if (!isSuccess) return;
    const pendingPayment = readPendingPayment();
    if (!pendingPayment?.email || !pendingPayment?.orderNo) return;
    window.sessionStorage.removeItem(PENDING_PAYMENT_KEY);
    createOrder(pendingPayment.email, pendingPayment.orderNo);
  }, [createOrder, isSuccess, state]);

  if (state !== "success" && state !== "cancel") {
    return (
      <main className="success-page page-shell">
        <section className="success-card payment-result payment-result--unknown">
          <div className="success-mark">?</div>
          <p className="eyebrow">Payment status unavailable</p>
          <h1>We could not confirm this payment.</h1>
          <p>Please return to checkout and try again.</p>
          <Link className="button" to="/checkout">Return to checkout</Link>
        </section>
      </main>
    );
  }

  return (
    <main className="success-page page-shell">
      <section className={`success-card payment-result ${isSuccess ? "payment-result--success" : "payment-result--cancel"}`}>
        <div className="success-mark">{isSuccess ? "✓" : "×"}</div>
        <p className="eyebrow">{isSuccess ? "Payment successful" : "Payment cancelled"}</p>
        <h1>{isSuccess ? "Thank you for your order." : "Your payment was cancelled."}</h1>
        <p>
          {isSuccess
            ? "Your payment has been completed and your games are now available."
            : "No payment was completed. Your items are still in the cart, so you can try again whenever you are ready."}
        </p>
        <div className="success-actions">
          <Link className="button" to={isSuccess ? "/shop" : "/checkout"}>
            {isSuccess ? "Continue shopping" : "Return to checkout"}
          </Link>
          {!isSuccess && <Link className="back-link" to="/cartpage">View cart</Link>}
        </div>
      </section>
    </main>
  );
};

export default PaymentResult;
